<script>
export default {
  props: {
    searchQuery: {
      type: String,
      default: '',
    },
    filterStatus: {
      type: String,
      default: '',
    },
    filterLanguage: {
      type: String,
      default: '',
    },
    filterCategory: {
      type: String,
      default: '',
    },
    filtersCollapsed: {
      type: Boolean,
      default: false,
    },
    availableStatuses: {
      type: Array,
      default: () => [],
    },
    availableLanguages: {
      type: Array,
      default: () => [],
    },
    availableCategories: {
      type: Array,
      default: () => [],
    },
  },
  emits: [
    'update:searchQuery',
    'update:filterStatus',
    'update:filterLanguage',
    'update:filterCategory',
    'update:filtersCollapsed',
    'clearFilters',
  ],
  computed: {
    hasActiveFilters() {
      return this.filterStatus || this.filterLanguage || this.filterCategory;
    },
  },
  methods: {
    getStatusLabel(status) {
      const key = `INBOX_MGMT.SETTINGS_POPUP.HSM_TEMPLATES.STATUS.${status?.toUpperCase()}`;
      const translated = this.$t(key);
      return translated !== key ? translated : status;
    },
    getCategoryLabel(category) {
      const key = `INBOX_MGMT.SETTINGS_POPUP.HSM_TEMPLATES.CATEGORIES.${category?.toUpperCase()}`;
      const translated = this.$t(key);
      return translated !== key ? translated : category;
    },
  },
};
</script>

<template>
  <div class="flex flex-col">
    <!-- Search -->
    <div class="p-3 border-b border-gray-200 dark:border-gray-700">
      <input
        :value="searchQuery"
        type="text"
        :placeholder="$t('WHATSAPP_TEMPLATES.PICKER.SEARCH_PLACEHOLDER')"
        class="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        @input="$emit('update:searchQuery', $event.target.value)"
      />
    </div>

    <!-- Filters (Collapsible) -->
    <div class="border-b border-gray-200 dark:border-gray-700">
      <button
        class="w-full p-3 flex items-center justify-between hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
        @click="$emit('update:filtersCollapsed', !filtersCollapsed)"
      >
        <span
          class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase flex items-center gap-2"
        >
          <fluent-icon
            icon="chevron-right"
            size="12"
            class="transition-transform duration-200"
            :class="{ 'rotate-90': !filtersCollapsed }"
          />
          {{ $t('INBOX_MGMT.SETTINGS_POPUP.HSM_TEMPLATES.FILTERS.TITLE') }}
        </span>
        <button
          v-if="hasActiveFilters"
          class="text-xs text-blue-600 hover:text-blue-800 dark:text-blue-400"
          @click.stop="$emit('clearFilters')"
        >
          {{ $t('INBOX_MGMT.SETTINGS_POPUP.HSM_TEMPLATES.FILTERS.CLEAR') }}
        </button>
      </button>
      <div v-show="!filtersCollapsed" class="px-3 pb-3 flex flex-col gap-2">
        <select
          :value="filterStatus"
          class="w-full text-xs px-2 py-1.5 border border-gray-300 rounded dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 dark:placeholder-gray-400"
          @change="$emit('update:filterStatus', $event.target.value)"
        >
          <option value="">
            {{
              $t('INBOX_MGMT.SETTINGS_POPUP.HSM_TEMPLATES.FILTERS.STATUS_LABEL')
            }}
          </option>
          <option
            v-for="status in availableStatuses"
            :key="status"
            :value="status"
          >
            {{ getStatusLabel(status) }}
          </option>
        </select>
        <select
          :value="filterLanguage"
          class="w-full text-xs px-2 py-1.5 border border-gray-300 rounded dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100"
          @change="$emit('update:filterLanguage', $event.target.value)"
        >
          <option value="">
            {{
              $t(
                'INBOX_MGMT.SETTINGS_POPUP.HSM_TEMPLATES.FILTERS.LANGUAGE_LABEL'
              )
            }}
          </option>
          <option v-for="lang in availableLanguages" :key="lang" :value="lang">
            {{ lang }}
          </option>
        </select>
        <select
          :value="filterCategory"
          class="w-full text-xs px-2 py-1.5 border border-gray-300 rounded dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100"
          @change="$emit('update:filterCategory', $event.target.value)"
        >
          <option value="">
            {{
              $t(
                'INBOX_MGMT.SETTINGS_POPUP.HSM_TEMPLATES.FILTERS.CATEGORY_LABEL'
              )
            }}
          </option>
          <option v-for="cat in availableCategories" :key="cat" :value="cat">
            {{ getCategoryLabel(cat) }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>
